import { ContentSitemapPagesEndpoint as ContentSitemapPagesEndpointInterface } from '@apiClient/interfaces/endpoints/ContentSitemapPages.endpoint';
import ApiResponseDto from '@apiClient/interfaces/response/ApiResponse.dto';
import { buildSearchParams } from '@/utils/handlers/urlHandler';
import { KyInstance } from "ky/distribution/types/ky";
import { KyResponse } from 'ky';
import { SitemapPageTemplate } from '@/projectRoot/api-client/interfaces/utils/misc';

export class ContentSitemapPagesEndpoint implements ContentSitemapPagesEndpointInterface {
    
    private _httpClient: KyInstance;
    private cache: RequestCache;

    public constructor(client: KyInstance, cache: RequestCache = "no-store") {
        this._httpClient = client;
        this.cache = cache;
    }

    get httpClient(): KyInstance {
        if (!this._httpClient) {
            throw new Error('Ky http client is not initialized');
        }
        return this._httpClient;
    }

    set httpClient(kyInstance: KyInstance) {
        this._httpClient = kyInstance;
    }

    /**
     * Return one of the sitemap pages by full url slug
     * The sitemapPagesSearch is used
     * api/content/sitemap-pages/by-full-url-slug
     */
    async singleByFullUrlSlug(fullUrlSlug: string, lang?: string): Promise<ApiResponseDto<SitemapPageTemplate, undefined>> {
        return this._httpClient
            .get(`content/sitemap-pages/by-full-url-slug`, { searchParams: buildSearchParams({ full_url_slug: fullUrlSlug, lang: lang }), cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText);
                }
                const response: ApiResponseDto<SitemapPageTemplate, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * Return one of the sitemap pages, typed
     * /api/content/sitemap-pages/draft/{id}
     */
    async draft(id: string): Promise<ApiResponseDto<SitemapPageTemplate, undefined>> {
        return this._httpClient
            .get(`content/sitemap-pages/draft/${id}`, { cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText);
                }
                const response: ApiResponseDto<SitemapPageTemplate, undefined> = await kyResponse.json();
                return response;
            });
    }
}

export default ContentSitemapPagesEndpoint;